export type EmptyStateProps = {
  icon: string
  title: string
  description: string
  primaryLabel?: string
  // Callback primaire : s'il est fourni, le bouton devient actif (hors
  // `primaryDisabled=true`). Sans callback, il reste désactivé en mode
  // « bientôt disponible » (tooltip explicite).
  onPrimaryClick?: () => void
  // Force le bouton primaire à l'état désactivé même si `onPrimaryClick`
  // est fourni (ex. bouton dispo mais désactivé par une condition métier).
  primaryDisabled?: boolean
  // Tooltip personnalisé quand désactivé (par défaut : « Bientôt disponible »).
  primaryTooltip?: string
  secondaryLabel?: string
  onSecondaryClick?: () => void
}

export function EmptyState({
  icon,
  title,
  description,
  primaryLabel,
  onPrimaryClick,
  primaryDisabled,
  primaryTooltip,
  secondaryLabel,
  onSecondaryClick,
}: EmptyStateProps) {
  const isPrimaryDisabled = primaryDisabled ?? !onPrimaryClick
  const tooltip = isPrimaryDisabled ? (primaryTooltip ?? 'Bientôt disponible') : undefined
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <span className="text-5xl mb-4">{icon}</span>
      <h2 className="text-xl font-semibold text-foreground mb-2">{title}</h2>
      <p className="text-sm text-muted-foreground max-w-md mb-6">{description}</p>
      <div className="flex gap-3">
        {primaryLabel && (
          <button
            type="button"
            disabled={isPrimaryDisabled}
            aria-disabled={isPrimaryDisabled || undefined}
            title={tooltip}
            onClick={isPrimaryDisabled ? undefined : onPrimaryClick}
            className={
              isPrimaryDisabled
                ? 'inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground opacity-50 cursor-not-allowed'
                : 'inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90'
            }
          >
            {primaryLabel}
          </button>
        )}
        {secondaryLabel && onSecondaryClick && (
          <button
            type="button"
            className="inline-flex items-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground"
            onClick={onSecondaryClick}
          >
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  )
}
